export default [
    {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/PageDashboard.vue"),
        meta: {
            title: "Dashboard",
            icon: "speedometer2",
        },
    },
    {
        path: "/training/dashboard",
        name: "training_dashboard",
        component: () => import("@/contrib/training/views/TrainingDashboard.vue"),
        meta: {
            title: "Stato formazione",
            icon: "clipboard-data",
            require: "workers_training.view_workercourse",
        },
    },
    {
        path: "/training/workers",
        name: "training_workers",
        component: () => import("@/contrib/training/views/WorkersList.vue"),
        meta: {
            title: "Lavoratori",
            icon: "people",
            require: "workers_training.view_worker",
        },
    },
    {
        path: "/training/worker/:id",
        name: "training_worker",
        props: true,
        component: () => import("@/contrib/training/views/WorkerView.vue"),
        meta: {
            title: "Dettaglio lavoratore",
            require: "workers_training.view_worker",
        },
    },
    {
        path: "/training/course-types",
        name: "training_course_types",
        component: () => import("@/contrib/training/views/CourseTypesList.vue"),
        meta: {
            title: "Tipi corso",
            icon: "list-ul",
            require: "workers_training.view_coursetype",
        },
    },
    {
        path: "/training/course-type/:id",
        name: "training_course_type",
        props: true,
        component: () => import("@/contrib/training/views/CourseTypeView.vue"),
        meta: {
            title: "Dettaglio tipo corso",
            require: "workers_training.view_coursetype",
        },
    },
    {
        path: "/training/courses",
        name: "training_courses",
        component: () => import("@/contrib/training/views/CoursesList.vue"),
        meta: {
            title: "Corsi (sessioni)",
            icon: "calendar-event",
            require: "workers_training.view_course",
        },
    },
    {
        path: "/training/course/:id",
        name: "training_course",
        props: true,
        component: () => import("@/contrib/training/views/CourseView.vue"),
        meta: {
            title: "Dettaglio corso",
            require: "workers_training.view_course",
        },
    },
    {
        path: "/training/certificates",
        name: "training_certificates",
        component: () => import("@/contrib/training/views/CertificatesList.vue"),
        meta: {
            title: "Attestati",
            icon: "patch-check",
            require: "workers_training.view_workercourse",
        },
    },
    {
        path: "/training/planning",
        name: "training_planning",
        component: () => import("@/contrib/training/views/PlanningView.vue"),
        meta: {
            title: "Pianificazione corsi",
            icon: "calendar-check",
            require: "workers_training.add_course",
        },
    },
    // {
    //     path: "/dl",
    //     name: "deadlines",
    //     component: () => import("@/views/ScadenziarioView.vue"),
    //     meta: {
    //         title: "Scadenze",
    //         icon: "calendar4-range",
    //     },
    // },
    {
        path: "/search",
        name: "search",
        component: () => import("@/views/SearchResults.vue"),
    },
    {
        path: "/report/:report_name",
        name: "report",
        props: true,
        component: () => import("@/views/VueReport.vue"),
    },
    {
        path: "/go/report/:report_name",
        name: "goreport",
        component: () => import("@/views/RedirectReport.vue"),
    },
    {
        path: "/customer/:id",
        name: "customer",
        props: true,
        component: () => import("@/contrib/customers/views/CustomerView.vue"),
    },
    {
        path: "/job/:id",
        name: "job",
        props: true,
        component: () => import("@/contrib/jobs/views/JobView.vue"),
    },
    {
        path: "/supplier/:id",
        name: "supplier",
        props: true,
        component: () => import("@/contrib/suppliers/views/SupplierView.vue"),
    },

];
